<template>
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="16"
        height="16"
        :fill="fillColor" 
        :class="svgClass" 
        viewBox="0 0 16 16"
    >
        <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
    </svg>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['fill', 'iconClass'])

const fillColor = computed(() => {
    return props.fill ? props.fill : 'black'
})

const svgClass = computed(() => {
    return props.iconClass ? props.iconClass : 'w-3.5 h-3.5'
})
</script>